module.exports = __webpack_public_path__ + "static/media/Circle-icons-motorcycle.svg.4a1917f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/PlatformManagement/BikeManagement/components/Circle-icons-motorcycle.svg.png
// module id = 2376
// module chunks = 0